import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-row-3" }
const _hoisted_3 = { class: "d-checkbox" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "d-row-3" }

import LoadingDownloandScreen from "@/components/util/LoadingDownloadScreen.vue";
import { computed, reactive } from "vue";
import { useReportStore } from "@/stores/report";
import { showToastError } from "@/toastification";
import { parseError } from "@/common/util";


export default /*@__PURE__*/_defineComponent({
  __name: 'DailyReportView',
  setup(__props) {

const state = reactive({
    dateMonth: { year: (new Date).getFullYear(), month: (new Date).getMonth() },
    monthlyOptions: { weekly: true, daily: true },
    showLoading: false,
    siteWorkPeriod: [ { year: (new Date).getFullYear(), month: (new Date).getMonth() }, { year: (new Date).getFullYear(), month: (new Date).getMonth()} ]
});

const reportStore = useReportStore();

const monthlyReportText = computed(() => {
    let result = "";
    if (state.monthlyOptions.weekly || state.monthlyOptions.daily) {
        result = "with ";
        if (state.monthlyOptions.weekly && state.monthlyOptions.daily) {
            result += "weekly and daily ";
        }
        else if (state.monthlyOptions.weekly) {
            result += "weekly ";
        }
        else if (state.monthlyOptions.daily) {
            result += "daily ";
        }
    }
    return result;
});

const siteWorkReportText = computed(() => {
    let result = "Generate Site work report from - to ";
    return result;
})

async function getMonthlyReport() {
    state.showLoading = true;
    try {
        await reportStore.downloadMonthly(state.dateMonth.year, state.dateMonth.month + 1,
            state.monthlyOptions.weekly, state.monthlyOptions.daily);
    }
    catch (e) {
        console.error(e);
        showToastError("Report was unable to generate: " + parseError(e));
    }
    finally {
        state.showLoading = false;
    }
}

async function getSiteWorkReport() {
    state.showLoading = true;
    try {
        if (state.siteWorkPeriod.length != 2) {
            showToastError("Error in entered time period.")
            return 
        }
        await reportStore.downloadSiteWork(
                state.siteWorkPeriod[0].year, 
                state.siteWorkPeriod[0].month + 1,  
                state.siteWorkPeriod[1].year,
                state.siteWorkPeriod[1].month + 1);
    } catch (e) {
        console.error(e);
        showToastError("Report was unable to generate: " + parseError(e));        
    } finally {
        state.showLoading = false;
    }
}


return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, "Get report for selected month " + _toDisplayString(monthlyReportText.value), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _cache[4] || (_cache[4] = _createElementVNode("label", null, "Month", -1)),
          _createVNode(_component_VueDatePicker, {
            modelValue: state.dateMonth,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.dateMonth) = $event)),
            "month-picker": "",
            clearable: false
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "weekly" }, "Weekly", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "weekly",
            id: "weekly",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.monthlyOptions.weekly) = $event))
          }, null, 512), [
            [_vModelCheckbox, state.monthlyOptions.weekly]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "daily" }, "Daily", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "daily",
            id: "daily",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.monthlyOptions.daily) = $event))
          }, null, 512), [
            [_vModelCheckbox, state.monthlyOptions.daily]
          ])
        ]),
        _createElementVNode("div", { class: "buttons" }, [
          _createElementVNode("button", {
            class: "accent",
            onClick: getMonthlyReport
          }, "Get report")
        ])
      ])
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"height":"1rem"} }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h4", null, "Get site work report for selected time period " + _toDisplayString(siteWorkReportText.value), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _cache[7] || (_cache[7] = _createElementVNode("label", null, "Time period to report", -1)),
          _createVNode(_component_VueDatePicker, {
            modelValue: state.siteWorkPeriod,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.siteWorkPeriod) = $event)),
            "month-picker": "",
            range: "",
            clearable: false
          }, null, 8, ["modelValue"])
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", { class: "buttons" }, [
          _createElementVNode("button", {
            class: "accent",
            onClick: getSiteWorkReport
          }, "Get report")
        ])
      ])
    ]),
    (state.showLoading)
      ? (_openBlock(), _createBlock(LoadingDownloandScreen, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})